<template>
  <div>
    <common-dialog
      ref="dialog"
      width="830px"
      edit-title
      title="实时统计"
      id-key="StayRegId"
      :data="data"
      form-label-width="90px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @details-opened="onDetailsOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-table border :data="tableData" size="small">
              <el-table-column prop="Addr" label="宿舍楼"/>
              <el-table-column prop="Zc" label="正常"/>
              <el-table-column prop="Wkq" label="未考勤"/>
              <el-table-column prop="Yc" label="异常"/>
              <el-table-column prop="Cd" label="迟到"/>
              <el-table-column prop="Qj" label="请假"/>
              <el-table-column prop="Yl" label="医疗"/>
              <el-table-column prop="Wgqq" label="无故缺勤"/>
              <el-table-column prop="Hj" label="合计"/>
            </el-table>
          </el-col>
        </el-row>
      </template>
      <template #footer>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/at/attendance").default,
      data: {
        
      },
      tableData: [],
      isMB: this.$store.state.isMB,
      rules: {
        
      },
    };
  },
  methods: {
    onDetailsOpened(data) {
      this.loading(true);
      this.api.getNightAttendanceStat({ AttendanceDate: data.AttendanceDate }).then(res => {
        this.loading(false);
        if(res.Code==0) {
          //--------------------
          // res.Data = [
          //   { Addr: "A栋", Zc: 20, Yc: 2, Cd: 3, Qj: 4, Yl: 1, Wgqq: 0, Hj: 30 },
          //   { Addr: "B栋", Zc: 30, Yc: 4, Cd: 6, Qj: 3, Yl: 5, Wgqq: 2, Hj: 50 },
          // ];
          //--------------------
          this.tableData = res.Data;
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    // summaryMethod(param) {
    //   const { columns, data } = param;
    //   const sums = [];
    //   columns.forEach((column, index) => {
    //     if (index === 0) {
    //       sums[index] = '合计';
    //       return;
    //     } else {
    //       const values = data.map(item =>Number(item[column.property]));   
    //       if (!values.every(value => isNaN(value))) {
    //         sums[index] = values.reduce((prev, curr) => {
    //           const value = Number(curr);
    //           if (!isNaN(value)) {
    //             return prev + value;
    //           } else {
    //             return prev;
    //           }
    //         }, 0);
    //       } else {
    //         sums[index] = '-';
    //       }
    //     }
    //   });
    //   return sums;
    // },
    onClosed() {
      this.tableData = [];
    },
  },
};
</script>